import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const amazonRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Amazon" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { AmazonCallback } = await import("./callback");
          return { Component: AmazonCallback };
        },
      },
    ],
  },
];
